import React, { useContext } from 'react';
import { Button } from '../../../../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { BlogContext } from 'features/ai-blog-writer/BlogContext';

const CheckAuthModel = ({
  setVisibleEditModel,
}: {
  setVisibleEditModel: (e: boolean) => void;
}) => {
  const navigate = useNavigate();
  const { blogContent } = useContext(BlogContext);

  return (
    <div className="fixed inset-0 z-[9999]">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/90 z-[9999]"
        onClick={() => setVisibleEditModel(false)}
      />

      {/* Modal */}
      <div className="fixed left-1/2 top-1/2 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background-card p-6 shadow-xl z-[9999]">
        <div className="text-xl font-bold text-primary"> Login or Sign Up?</div>
        <div className="mb-5 mt-2.5 text-[15px] leading-normal text-text-primary">
          To proceed with more blog features, please log in to your existing
          account or sign up to create a new one.
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <Button
            variant="customPrimary"
            size="sm"
            onClick={() => setVisibleEditModel(false)}
          >
            Close
          </Button>{' '}
          <Button
            variant="customPrimary"
            size="sm"
            onClick={() => {
              localStorage.setItem(
                'blogContext',
                JSON.stringify(blogContent || '')
              );
              navigate('/auth/register');
            }}
          >
            Sign Up
          </Button>{' '}
          <Button
            variant="customPrimary"
            size="sm"
            onClick={() => {
              localStorage.setItem(
                'blogContext',
                JSON.stringify(blogContent || '')
              );
              navigate('/auth/login');
            }}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckAuthModel;
